// ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐºÐ¾Ð½ÐºÑÐµÑÐ½Ð¾Ð³Ð¾ Ð±ÑÐ¾ÐºÐµÑÐ° Ð¿Ð¾Ð²ÐµÑÑ Ð±ÑÐµÐ½Ð´Ð°.
//
// ÐÑÐµÐ½Ð´ (REACT_APP_BRAND) â ÑÑÐ¾ Ð¿Ð°Ð»Ð¸ÑÑÐ° Ð¸ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿, Ð¸ Horizon Ð¾Ð±ÑÐ¸Ð¹ Ñ Rox Ð¸ JetQ.
// Ð Ð²Ð¾Ñ ÑÑÐ¾ Ð±ÑÐ¾ÐºÐµÑ Ð¿ÑÐ¾Ð´Ð°ÑÑ Ð¸ ÐºÐ°Ðº Ð½Ð°Ð·ÑÐ²Ð°ÐµÑÑÑ â Ñ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ ÑÐ²Ð¾Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð°Ñ
// Ð¿ÐµÑÐµÐ¼ÐµÐ½Ð½Ð°Ñ ÑÐ±Ð¾ÑÐºÐ¸:
//
//   REACT_APP_TENANT=        â ÐºÐ°Ðº Ð±ÑÐ»Ð¾ (DOSCAR, Rox)
//   REACT_APP_TENANT=jetq    â JetQ: ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ
//                              Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, ÑÐ²Ð¾Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ°
//   REACT_APP_TENANT=mega    â MEGA: ÐºÐ°Ðº JetQ (ÑÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ, ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾
//                              Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ), ÑÐ²Ð¾Ñ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð¸ Ð±ÐµÐ· Ð·Ð½Ð°ÑÐºÐ°
import { CAR_ORIGIN_TYPES } from '../constants/carOrigin';

export const TENANTS = {
  jetq: {
    title: 'JetQ',
    // public/assets â Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸; Ñ Ð¾ÑÑÐ°Ð»ÑÐ½ÑÑ Ð¾ÑÑÐ°ÑÑÑÑ apple-touch-icon.png.
    favicon: '/assets/jetq-icon.png',
    // ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾ JetQ Ð¿ÑÐ¾Ð´Ð°ÑÑ â ÑÐ°Ð·Ð´ÐµÐ»Ñ Ð² Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÑÂ» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð°ÑÂ» Ð½Ð° Ð¼ÐµÑÑÐµ,
    // ÐºÐ°Ðº Ñ DOSCAR (Ð²ÐµÑÐ½ÑÐ»Ð¸ 14.10.2026 Ð¿Ð¾ Ð¿ÑÐ¾ÑÑÐ±Ðµ ÐÐ¸Ð¼Ñ).
    // ÐÐ°ÑÐ¸Ð½Ñ Ñ Ð¿ÑÐ¾Ð±ÐµÐ³Ð¾Ð¼ JetQ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ; Ð½Ð° Ð½Ð¾Ð²ÑÐµ
    // ÑÑÐ¾ Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸Ðµ Ð½Ðµ ÑÐ°ÑÐ¿ÑÐ¾ÑÑÑÐ°Ð½ÑÐµÑÑÑ â ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑÑÑ
    // Ð»Ð¸ÑÑ Ð² ÑÐµÐ¶Ð¸Ð¼Ðµ Â«ÐÐ£ Ð°Ð²ÑÐ¾Â».
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    // Ð¡ÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ ÑÐ¾ÑÐ³ÑÐµÑ Ð»ÑÐ±ÑÐ¼Ð¸ Ð¼Ð°ÑÐºÐ°Ð¼Ð¸: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ Ð¼Ð°ÑÐºÑ, Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¸
    // ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ Ð¿ÑÑÐ¼Ð¾ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð°Ð²ÑÐ¾, Ð½Ðµ Ð´Ð¾Ð¶Ð¸Ð´Ð°ÑÑÑ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÐ°.
    managersAddDictionaries: true,
    // Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾Ñ (ÐÐ³ÐµÐ½Ñ â ÐÑÐ¾Ð´Ð°Ð²ÐµÑ â ÐÐ¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ) Ð¿Ð¾ÐºÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR.
    // Ð£ JetQ Ð²ÑÐµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ â Ð±ÐµÐ· Ð²ÑÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ ÑÐ°Ð³ Ð²ÑÑÐ°Ð» Ð±Ñ Ð² ÐºÐ°Ð¶Ð´ÑÑ ÑÐ´ÐµÐ»ÐºÑ.
    tripartiteContract: false,
  },
  // ÐÐ°ÑÑÐ½ÑÑÑ-ÑÐµÑÑÐµ Ð´Ð¸Ð»ÐµÑÑ Ð·Ð°Ð²Ð¾Ð´ÑÑÑÑ Ð¿Ð¾ Ð¾Ð±ÑÐ°Ð·ÑÑ MEGA: Ð¾ÑÐ»Ð¸ÑÐ°ÐµÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ
  // Ð²ÐºÐ»Ð°Ð´ÐºÐ¸. ÐÐ¾ÐºÐ° Ñ Ð²ÑÐµÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¹ Ð½Ð°Ð±Ð¾Ñ â ÑÐ¾Ð»ÑÐºÐ¾ ÐÐ£-Ð°Ð²ÑÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ,
  // Ð¼Ð°ÑÐºÐ¸ Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð·Ð°Ð²Ð¾Ð´ÑÑ ÑÐ°Ð¼Ð¸. ÐÑÐ»Ð¸ ÐºÑÐ¾-ÑÐ¾ Ð½Ð°ÑÐ½ÑÑ Ð¿ÑÐ¾Ð´Ð°Ð²Ð°ÑÑ Ð½Ð¾Ð²ÑÐµ
  // Ð°Ð²ÑÐ¾, Ñ Ð½ÐµÐ³Ð¾ Ð¿Ð¾ÑÐ²ÑÑÑÑ ÑÐ²Ð¾Ð¸ carOrigins, ÐºÐ°Ðº Ð±ÑÐ»Ð¾ Ñ JetQ.
  evmst: {
    title: 'EV-MASTER',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    tripartiteContract: false,
    managersAddDictionaries: true,
  },
  bayc: {
    title: 'Bay Cars',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    tripartiteContract: false,
    managersAddDictionaries: true,
  },
  tswg: {
    title: 'TSW Group',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    tripartiteContract: false,
    managersAddDictionaries: true,
  },
  drvpt: {
    title: 'Drive Point Auto',
    favicon: null,
    usedCarsOnly: true,
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    tripartiteContract: false,
    managersAddDictionaries: true,
  },
  mega: {
    title: 'MEGA',
    // Ð¡Ð²Ð¾ÐµÐ¹ Ð¸ÐºÐ¾Ð½ÐºÐ¸ Ñ Ð¿Ð°ÑÑÐ½ÑÑÐ° Ð½ÐµÑ, Ð° Ð½Ð°Ñ Ð»Ð¾Ð³Ð¾ÑÐ¸Ð¿ Ð½Ð° ÐµÐ³Ð¾ Ð²ÐºÐ»Ð°Ð´ÐºÐµ Ð»Ð¸ÑÐ½Ð¸Ð¹:
    // null â ÑÑÐ¾ Â«ÑÐ±ÑÐ°ÑÑ Ð·Ð½Ð°ÑÐ¾ÐºÂ», Ð° Ð½Ðµ Â«Ð¾ÑÑÐ°Ð²Ð¸ÑÑ ÐºÐ°Ðº ÐµÑÑÑÂ» (ÑÐ¼. applyTenant).
    favicon: null,
    // MEGA â ÑÐµÑÑÐ¹ Ð´Ð¸Ð»ÐµÑ, ÐºÐ°Ðº JetQ: Ð½Ð¾Ð²ÑÑ Ð°Ð²ÑÐ¾ Ð½ÐµÑ, Ð¼Ð°ÑÐ¸Ð½Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ
    // Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ Ð½Ðµ Ð¿ÑÐ¸Ð²ÑÐ·Ð°Ð½ Ðº Ð¼Ð°ÑÐºÐµ.
    usedCarsOnly: true,
    carOrigins: [CAR_ORIGIN_TYPES.CONSIGNMENT],
    tripartiteContract: false,
    managersAddDictionaries: true,
  },
};

export const resolveTenant = (value) => {
  const key = String(value || '').trim().toLowerCase();
  return TENANTS[key] || null;
};

export const tenant = resolveTenant(process.env.REACT_APP_TENANT);

// Ð Ð°Ð·Ð´ÐµÐ»Ñ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» Ð² Ð¼ÐµÐ½Ñ Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð¸Â».
const NEW_CARS_PATHS = ['/cars/new', '/deals/new'];

// Ð Ð°Ð·Ð´ÐµÐ» Â«Ð¥Ð°Ð»ÑÐºÂ» Ð² Â«ÐÑÐ¾Ð´Ð°Ð¶Ð°ÑÂ»: Halyk Market Ð¿Ð¾Ð´ÐºÐ»ÑÑÑÐ½ ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR, Ñ Ð¿Ð°ÑÑÐ½ÑÑÐ¾Ð²
// (ÑÐµÑÑÑ Ð´Ð¸Ð»ÐµÑÐ¾Ð²) ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ tenant ÐµÐ³Ð¾ Ð½ÐµÑ.
const HALYK_PATHS = ['/deals/halyk'];

/**
 * ÐÑÐ½ÐºÑÑ Ð¼ÐµÐ½Ñ Â«ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸Â» Ð¸ Â«ÐÑÐ¾Ð´Ð°Ð¶Ð¸Â»: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÐÐ£-Ð°Ð²ÑÐ¾ Â«ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾Â» ÑÐ±Ð¸ÑÐ°ÐµÐ¼,
 * Ð° ÑÐ°Ð·Ð´ÐµÐ» Â«Ð¥Ð°Ð»ÑÐºÂ» Ð¾ÑÑÐ°Ð²Ð»ÑÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ñ DOSCAR (Ð±ÐµÐ· tenant).
 */
export const usedOnlyMenuChildren = (children, current = tenant) =>
  current
    ? children.filter(
        (item) =>
          !HALYK_PATHS.includes(item.path) &&
          !(current.usedCarsOnly && NEW_CARS_PATHS.includes(item.path))
      )
    : children;

/** ÐÐ°ÑÐ¸Ð°Ð½ÑÑ Â«ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÑÂ»: Ñ Ð±ÑÐ¾ÐºÐµÑÐ° ÑÐ¾ ÑÐ²Ð¾Ð¸Ð¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ â ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð½Ð¸. */
export const allowedOriginOptions = (options, current = tenant) =>
  current?.carOrigins ? options.filter((option) => current.carOrigins.includes(option.value)) : options;

/** ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸ Ð¸ÐºÐ¾Ð½ÐºÐ° Ð²ÐºÐ»Ð°Ð´ÐºÐ¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ°. */
export const applyTenant = (doc = document, current = tenant) => {
  if (!current) return;
  if (current.title) doc.title = current.title;
  if (!('favicon' in current)) return;

  const links = doc.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]');
  if (current.favicon) {
    links.forEach((link) => link.setAttribute('href', current.favicon));
  } else {
    links.forEach((link) => link.remove());
  }
};

/** ÐÐ¾Ð¶ÐµÑ Ð»Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑ Ð¼Ð°ÑÐºÐ¸, Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¸ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸ ÑÐ°Ð¼ (ÑÐµÑÑÐµ Ð´Ð¸Ð»ÐµÑÑ). */
export const managersAddDictionaries = (current = tenant) => current?.managersAddDictionaries === true;

/** ÐÑÐ¶ÐµÐ½ Ð»Ð¸ ÑÐ°Ð³ Â«Ð¢ÑÑÑÑÑÐ¾ÑÐ¾Ð½Ð½Ð¸Ð¹ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÂ» Ð² ÑÐ´ÐµÐ»ÐºÐ°Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ. */
export const tripartiteContractEnabled = (current = tenant) => current?.tripartiteContract !== false;
